// // Single entry point for all data access. Components import from "../../api".
// import { respond, respondOne, byOrder, LIVE, apiGet, apiPost } from "./client";
// import { submitLead as submitLeadStatic } from "./leads";

// import siteConfig from "../data/siteConfig";
// import navigation from "../data/navigation";
// import doctors, { departments } from "../data/doctors";
// import timetable, { weekDays } from "../data/timetable";
// import services from "../data/services";
// import packages from "../data/packages";
// import blogs from "../data/blogs";
// import gallery, { galleryCategories } from "../data/gallery";
// import testimonials, { ratingSummary } from "../data/testimonials";
// import legal from "../data/legal";
// import assessments from "../data/assessments";
// import conditions from "../data/conditions";
// import { licenses, awards, trustBadges } from "../data/credentials";
// import { publicResponses } from "../data/messages";
// import faqs, { faqCategories } from "../data/faqs";
// import videos from "../data/videos";
// import management from "../data/management";
// import pageContent from "../data/pageContent";
// import { heroSlides } from "../data/content";

// export { submitLead, getLeads } from "./leads";

// // ---- site ----
// export const getSiteConfig = () => respond(siteConfig, 0);
// export const getNavigation = () => respond(navigation, 0);
// export const getPageContent = () => respond(pageContent, 0);

// // ---- home ----
// export const getHeroSlides = () => respond(heroSlides, 0);

// // ---- doctors (backend: Settings app, website_api/...) ----
// export const getDepartments = () =>
//   LIVE ? apiGet("/website_api/departments/") : respond(departments);
// export const getDoctors = ({ department, featured } = {}) =>
//   LIVE
//     ? apiGet("/website_api/doctors/", { department, featured })
//     : respond(
//         doctors
//           .filter((d) => !department || d.department === department)
//           .filter((d) => featured === undefined || d.featured === featured)
//           .sort(byOrder),
//       );
// export const getDoctor = (id) =>
//   LIVE
//     ? apiGet(`/website_api/doctors/${encodeURIComponent(id)}/`)
//     : respondOne(
//         doctors.find((d) => String(d.id) === String(id) || d.slug === id),
//       );

// // ---- timetable ----
// export const getWeekDays = () => respond(weekDays, 0);
// export const getTimetable = ({ doctorId } = {}) =>
//   LIVE
//     ? apiGet("/website_api/timetable/", { doctor: doctorId })
//     : respond(
//         timetable.filter(
//           (t) => !doctorId || String(t.doctorId) === String(doctorId),
//         ),
//       );

// // ---- appointments ----
// // Booking rules (capacity, approved seats) live in the backend: Settings/appointment_service.py
// const STATIC_PER_HOUR = 10;
// const toMinutes = (hhmm) => {
//   const [h, m] = hhmm.split(":").map(Number);
//   return h * 60 + m;
// };
// const DAY_NAMES = [
//   "Sunday",
//   "Monday",
//   "Tuesday",
//   "Wednesday",
//   "Thursday",
//   "Friday",
//   "Saturday",
// ];

// export const getAppointmentSetting = () =>
//   LIVE
//     ? apiGet("/website_api/appointment_setting/")
//     : respond({ websiteBooking: true, bookingDaysAhead: 60, notice: "" }, 0);

// /** Chamber sessions of a doctor on a date, with free seats. */
// export const getAppointmentAvailability = (doctorId, date) => {
//   if (LIVE)
//     return apiGet("/website_api/appointment_availability/", {
//       doctor: doctorId,
//       date,
//     });
//   const day = DAY_NAMES[new Date(`${date}T00:00:00`).getDay()];
//   const sessions = timetable
//     .filter((t) => String(t.doctorId) === String(doctorId) && t.day === day)
//     .map((t) => {
//       const capacity = Math.floor(
//         ((toMinutes(t.end) - toMinutes(t.start)) / 60) * STATIC_PER_HOUR,
//       );
//       return {
//         schedule: t.id,
//         doctor: t.doctorId,
//         day,
//         start: t.start,
//         end: t.end,
//         title: t.title,
//         type: t.type,
//         capacity,
//         approved: 0,
//         pending: 0,
//         remaining: capacity,
//         is_full: false,
//       };
//     });
//   return respond({ doctor: doctorId, date, sessions }, 0);
// };

// /** Book an appointment. Saved as "pending"; the team approves it from the software. */
// export const bookAppointment = ({
//   doctorId,
//   scheduleId,
//   date,
//   name,
//   phone,
//   doctorName,
//   sessionLabel,
// }) =>
//   LIVE
//     ? apiPost("/website_api/appointments/", {
//         doctor: Number(doctorId),
//         schedule: Number(scheduleId),
//         date,
//         patient_name: name,
//         phone,
//       })
//     : submitLeadStatic("appointment", {
//         doctorId,
//         doctorName,
//         scheduleId,
//         date,
//         name,
//         phone,
//         timeLabel: sessionLabel,
//       });

// // ---- services ----
// export const getServices = () => respond([...services].sort(byOrder));
// export const getService = (id) =>
//   respondOne(
//     services.find((s) => String(s.id) === String(id) || s.slug === id),
//   );

// // ---- packages ----
// export const getPackages = () => respond([...packages].sort(byOrder));
// export const getPackage = (id) =>
//   respondOne(
//     packages.find((p) => String(p.id) === String(id) || p.slug === id),
//   );

// // ---- blogs ----
// export const getBlogs = ({ limit, category } = {}) => {
//   const list = blogs.filter((b) => !category || b.category === category);
//   return respond(limit ? list.slice(0, limit) : list);
// };
// export const getBlogCategories = () =>
//   respond([...new Set(blogs.map((b) => b.category))]);
// export const getRelatedBlogs = (id, limit = 3) => {
//   const current = blogs.find(
//     (b) => String(b.id) === String(id) || b.slug === id,
//   );
//   const others = blogs.filter((b) => b !== current);
//   const same = others.filter((b) => current && b.category === current.category);
//   return respond(
//     [...same, ...others.filter((b) => !same.includes(b))].slice(0, limit),
//   );
// };
// export const getBlog = (id) =>
//   respondOne(blogs.find((b) => String(b.id) === String(id) || b.slug === id));

// // ---- gallery ----
// export const getGalleryCategories = () => respond(galleryCategories);
// export const getGallery = ({ category } = {}) =>
//   respond(gallery.filter((g) => !category || g.category === category));

// // ---- testimonials ----
// export const getTestimonials = () =>
//   respond({ items: testimonials, summary: ratingSummary });

// // ---- management ----
// export const getManagement = () => respond(management);

// // ---- self-assessment ----
// export const getAssessments = () => respond(assessments, 0);
// export const getAssessment = (id) =>
//   respondOne(
//     assessments.find((a) => a.id === id),
//     0,
//   );

// // ---- conditions / credentials ----
// export const getConditions = () => respond(conditions);
// export const getLicenses = () => respond(licenses);
// export const getAwards = () => respond(awards);
// export const getTrustBadges = () => respond(trustBadges, 0);

// // ---- anonymous message answers ----
// export const getPublicResponses = () =>
//   respond(
//     [...publicResponses].sort((a, b) =>
//       b.pinned === a.pinned ? b.date.localeCompare(a.date) : b.pinned ? 1 : -1,
//     ),
//   );

// // ---- FAQ ----
// export const getFaqCategories = () => respond(faqCategories);
// export const getFaqs = ({ category, featured } = {}) =>
//   respond(
//     faqs.filter(
//       (f) =>
//         (!category || f.category === category) &&
//         (featured === undefined || f.featured === featured),
//     ),
//   );

// // ---- videos ----
// export const getVideos = () => respond(videos);

// // ---- legal pages ----
// export const getLegalPage = (slug) => respondOne(legal[slug]);

// // ---- site search (header search box) ----
// export const search = async (query) => {
//   const q = String(query || "")
//     .trim()
//     .toLowerCase();
//   if (!q)
//     return respond({ doctors: [], services: [], packages: [], blogs: [] });
//   const doctorList = LIVE ? await getDoctors().catch(() => []) : doctors;
//   const has = (...fields) =>
//     fields.filter(Boolean).join(" ").toLowerCase().includes(q);
//   return respond({
//     doctors: doctorList.filter((d) =>
//       has(
//         d.name,
//         d.designation,
//         d.speciality,
//         d.degrees,
//         ...(d.expertise || []),
//       ),
//     ),
//     services: services.filter((s) =>
//       has(s.title, s.desc, ...(s.conditions || [])),
//     ),
//     packages: packages.filter((p) =>
//       has(p.name, p.description, ...(p.includes || [])),
//     ),
//     blogs: blogs.filter((b) => has(b.title, b.category, ...(b.content || []))),
//   });
// };

// Single entry point for all data access. Components import from "../../api".
import {
  respond,
  respondOne,
  byOrder,
  LIVE,
  apiGet,
  apiPost,
  NotFoundError,
} from "./client";
import { submitLead as submitLeadStatic } from "./leads";

import siteConfig from "../data/siteConfig";
import navigation from "../data/navigation";
import doctors, { departments } from "../data/doctors";
import timetable, { weekDays } from "../data/timetable";
import services from "../data/services";
import packages from "../data/packages";
import blogs from "../data/blogs";
import gallery, { galleryCategories } from "../data/gallery";
import testimonials, { ratingSummary } from "../data/testimonials";
import legal from "../data/legal";
import assessments from "../data/assessments";
import conditions from "../data/conditions";
import { licenses, awards, trustBadges } from "../data/credentials";
import { publicResponses } from "../data/messages";
import faqs, { faqCategories } from "../data/faqs";
import videos from "../data/videos";
import management from "../data/management";
import pageContent from "../data/pageContent";
import { heroSlides } from "../data/content";

export { submitLead, getLeads } from "./leads";

// ---- live data (backend: Website app, website_api/...) ----
// Same request within a minute is answered from memory (many sections load the same list).
const CACHE_MS = 60 * 1000;
const cache = {};
const copy = (value) => JSON.parse(JSON.stringify(value));
const liveGet = (path) => {
  const hit = cache[path];
  if (hit && Date.now() - hit.at < CACHE_MS) return hit.promise.then(copy);
  const promise = apiGet(path);
  cache[path] = { at: Date.now(), promise };
  promise.catch(() => delete cache[path]);
  return promise.then(copy);
};

/** LIVE: `website_api/<name>/` (static data if the server cannot be reached). Otherwise the static data. */
const list = (name, staticData, delay) =>
  LIVE
    ? liveGet(`/website_api/${name}/`).catch(() => copy(staticData))
    : respond(staticData, delay);

const findOne = (promise, match) =>
  promise.then((items) => {
    const item = items.find(match);
    if (!item) throw new NotFoundError();
    return item;
  });

const byIdOrSlug = (id) => (x) => String(x.id) === String(id) || x.slug === id;

// ---- site ----
export const getSiteConfig = () =>
  LIVE
    ? liveGet("/website_api/site_config/")
        .then((live) => ({ ...siteConfig, ...live }))
        .catch(() => copy(siteConfig))
    : respond(siteConfig, 0);
export const getNavigation = () => respond(navigation, 0);
export const getPageContent = () =>
  LIVE
    ? liveGet("/website_api/page_content/")
        .then((live) => ({ ...pageContent, ...live })) // a block not saved yet keeps the default text
        .catch(() => copy(pageContent))
    : respond(pageContent, 0);

// ---- home ----
export const getHeroSlides = () =>
  LIVE
    ? getPageContent().then((c) => c.heroSlides || heroSlides)
    : respond(heroSlides, 0);

// ---- doctors (backend: Settings app, website_api/...) ----
export const getDepartments = () =>
  LIVE ? apiGet("/website_api/departments/") : respond(departments);
export const getDoctors = ({ department, featured } = {}) =>
  LIVE
    ? apiGet("/website_api/doctors/", { department, featured })
    : respond(
        doctors
          .filter((d) => !department || d.department === department)
          .filter((d) => featured === undefined || d.featured === featured)
          .sort(byOrder),
      );
export const getDoctor = (id) =>
  LIVE
    ? apiGet(`/website_api/doctors/${encodeURIComponent(id)}/`)
    : respondOne(
        doctors.find((d) => String(d.id) === String(id) || d.slug === id),
      );

// ---- timetable ----
export const getWeekDays = () => respond(weekDays, 0);
export const getTimetable = ({ doctorId } = {}) =>
  LIVE
    ? apiGet("/website_api/timetable/", { doctor: doctorId })
    : respond(
        timetable.filter(
          (t) => !doctorId || String(t.doctorId) === String(doctorId),
        ),
      );

// ---- appointments ----
// Booking rules (capacity, approved seats) live in the backend: Settings/appointment_service.py
const STATIC_PER_HOUR = 10;
const toMinutes = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
};
const DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const getAppointmentSetting = () =>
  LIVE
    ? apiGet("/website_api/appointment_setting/")
    : respond({ websiteBooking: true, bookingDaysAhead: 60, notice: "" }, 0);

/** Chamber sessions of a doctor on a date, with free seats. */
export const getAppointmentAvailability = (doctorId, date) => {
  if (LIVE)
    return apiGet("/website_api/appointment_availability/", {
      doctor: doctorId,
      date,
    });
  const day = DAY_NAMES[new Date(`${date}T00:00:00`).getDay()];
  const sessions = timetable
    .filter((t) => String(t.doctorId) === String(doctorId) && t.day === day)
    .map((t) => {
      const capacity = Math.floor(
        ((toMinutes(t.end) - toMinutes(t.start)) / 60) * STATIC_PER_HOUR,
      );
      return {
        schedule: t.id,
        doctor: t.doctorId,
        day,
        start: t.start,
        end: t.end,
        title: t.title,
        type: t.type,
        capacity,
        approved: 0,
        pending: 0,
        remaining: capacity,
        is_full: false,
      };
    });
  return respond({ doctor: doctorId, date, sessions }, 0);
};

/** Book an appointment. Saved as "pending"; the team approves it from the software. */
export const bookAppointment = ({
  doctorId,
  scheduleId,
  date,
  name,
  phone,
  doctorName,
  sessionLabel,
}) =>
  LIVE
    ? apiPost("/website_api/appointments/", {
        doctor: Number(doctorId),
        schedule: Number(scheduleId),
        date,
        patient_name: name,
        phone,
      })
    : submitLeadStatic("appointment", {
        doctorId,
        doctorName,
        scheduleId,
        date,
        name,
        phone,
        timeLabel: sessionLabel,
      });

// ---- services ----
export const getServices = () =>
  list("services", services).then((l) => [...l].sort(byOrder));
export const getService = (id) => findOne(getServices(), byIdOrSlug(id));

// ---- packages ----
export const getPackages = () =>
  list("packages", packages).then((l) => [...l].sort(byOrder));
export const getPackage = (id) => findOne(getPackages(), byIdOrSlug(id));

// ---- blogs ----
const allBlogs = () => list("blogs", blogs);
export const getBlogs = ({ limit, category } = {}) =>
  allBlogs().then((all) => {
    const filtered = all.filter((b) => !category || b.category === category);
    return limit ? filtered.slice(0, limit) : filtered;
  });
export const getBlogCategories = () =>
  allBlogs().then((all) => [...new Set(all.map((b) => b.category))]);
export const getRelatedBlogs = (id, limit = 3) =>
  allBlogs().then((all) => {
    const current = all.find(byIdOrSlug(id));
    const others = all.filter((b) => b !== current);
    const same = others.filter(
      (b) => current && b.category === current.category,
    );
    return [...same, ...others.filter((b) => !same.includes(b))].slice(
      0,
      limit,
    );
  });
export const getBlog = (id) => findOne(allBlogs(), byIdOrSlug(id));

// ---- gallery ----
export const getGalleryCategories = () =>
  list("gallery_categories", galleryCategories);
export const getGallery = ({ category } = {}) =>
  list("gallery", gallery).then((all) =>
    all.filter((g) => !category || g.category === category),
  );

// ---- testimonials ----
export const getTestimonials = () =>
  LIVE
    ? Promise.all([list("testimonials", testimonials), getPageContent()]).then(
        ([items, content]) => ({
          items,
          summary: content.ratingSummary || ratingSummary,
        }),
      )
    : respond({ items: testimonials, summary: ratingSummary });

// ---- management ----
export const getManagement = () => list("team", management);

// ---- self-assessment (questions stay in the website: standard screening tools) ----
export const getAssessments = () => respond(assessments, 0);
export const getAssessment = (id) =>
  respondOne(
    assessments.find((a) => a.id === id),
    0,
  );

// ---- conditions / credentials ----
export const getConditions = () =>
  LIVE
    ? getPageContent().then((c) => c.conditions || conditions)
    : respond(conditions);
export const getLicenses = () => list("licenses", licenses);
export const getAwards = () => list("awards", awards);
export const getTrustBadges = () => list("trust_badges", trustBadges, 0);

// ---- anonymous message answers ----
export const getPublicResponses = () =>
  list("public_responses", publicResponses).then((all) =>
    [...all].sort((a, b) =>
      b.pinned === a.pinned ? b.date.localeCompare(a.date) : b.pinned ? 1 : -1,
    ),
  );

// ---- FAQ ----
export const getFaqCategories = () => list("faq_categories", faqCategories);
export const getFaqs = ({ category, featured } = {}) =>
  list("faqs", faqs).then((all) =>
    all.filter(
      (f) =>
        (!category || f.category === category) &&
        (featured === undefined || f.featured === featured),
    ),
  );

// ---- videos ----
export const getVideos = () => list("videos", videos);

// ---- legal pages ----
export const getLegalPage = (slug) =>
  LIVE
    ? liveGet("/website_api/legal/")
        .catch(() => copy(legal))
        .then((pages) => {
          if (!pages[slug]) throw new NotFoundError();
          return pages[slug];
        })
    : respondOne(legal[slug]);

// ---- site search (header search box) ----
export const search = async (query) => {
  const q = String(query || "")
    .trim()
    .toLowerCase();
  if (!q)
    return respond({ doctors: [], services: [], packages: [], blogs: [] });
  const [doctorList, serviceList, packageList, blogList] = await Promise.all([
    getDoctors().catch(() => []),
    getServices().catch(() => []),
    getPackages().catch(() => []),
    allBlogs().catch(() => []),
  ]);
  const has = (...fields) =>
    fields.filter(Boolean).join(" ").toLowerCase().includes(q);
  return {
    doctors: doctorList.filter((d) =>
      has(
        d.name,
        d.designation,
        d.speciality,
        d.degrees,
        ...(d.expertise || []),
      ),
    ),
    services: serviceList.filter((s) =>
      has(s.title, s.desc, ...(s.conditions || [])),
    ),
    packages: packageList.filter((p) =>
      has(p.name, p.description, ...(p.includes || [])),
    ),
    blogs: blogList.filter((b) =>
      has(b.title, b.category, ...(b.content || [])),
    ),
  };
};
